import deleteData from "../services/deleteData";
import fetchData from "../services/fetchData";
import patchData from "../services/patchData";
import postData from "../services/postData";

const handleFetchAutoRequests = async ({
  page,
  limit,
  status,
  params,
}: any) => {
  const uri = `v1/autorequests?page=${page}&limit=${limit}&status=${status}&${params}`;
  const response = fetchData({ uri });
  return response;
};

const handleFetchAutoRequest = async ({ _id }: any) => {
  const uri = `v1/autorequests/${_id}`;
  const response = fetchData({ uri });
  return response;
};

const handleAcceptAutoRequest = async ({ _id, data }: any) => {
  const uri = `v1/autorequests/${_id}/accept`;
  const response = patchData({ uri, data });
  return response;
};

const handleRejectAutoRequest = async ({ _id, data }: any) => {
  const uri = `v1/autorequests/${_id}/reject`;
  const response = patchData({ uri, data });
  return response;
};

const handleExportAutoRequests = async () => {
  const uri = `v1/autorequests/export/all`;
  const response = fetchData({ uri });
  return response;
};

const handleFetchAutoRequestsCount = async ({ status }: any) => {
  const uri = `v1/autorequests/count/all?status=${status}`;
  const response = fetchData({ uri });
  return response;
};

const handleCreateAutoRequest = async (data: any) => {
  const uri = `v1/autorequests`;
  const response = postData({ data, uri });
  return response;
};

const handleUpdateAutoRequest = async ({ _id, data }: any) => {
  const uri = `v1/autorequests/${_id}`;
  const response = patchData({ data, uri });
  return response;
};

const handleUpdateAutoRequester = async ({ _id, data }: any) => {
  const uri = `v1/autorequests/${_id}/requester`;
  const response = patchData({ data, uri });
  return response;
};

const handleUpdateRequestedFor = async ({ _id, data }: any) => {
  const uri = `v1/autorequests/${_id}/requested-for`;
  const response = patchData({ data, uri });
  return response;
};

const handleUpdateRequestedDate = async ({ _id, data }: any) => {
  const uri = `v1/autorequests/${_id}/date-requested`;
  const response = patchData({ data, uri });
  return response;
};

const handleUpdateDateApproved = async ({ _id, data }: any) => {
  const uri = `v1/autorequests/${_id}/date-approved`;
  const response = patchData({ data, uri });
  return response;
};

const handleUpdateDateExecuted = async ({ _id, data }: any) => {
  const uri = `v1/autorequests/${_id}/date-executed`;
  const response = patchData({ data, uri });
  return response;
};

const handleUpdateAutoExecutor = async ({ _id, data }: any) => {
  const uri = `v1/autorequests/${_id}/executor`;
  const response = patchData({ data, uri });
  return response;
};

const handleMoveToAutoExecutor = async ({ _id, data }: any) => {
  const uri = `v1/autorequests/${_id}/move/executor`;
  const response = patchData({ data, uri });
  return response;
};

const handleUpdateAutoApprover = async ({ _id, data }: any) => {
  const uri = `v1/autorequests/${_id}/approver`;
  const response = patchData({ data, uri });
  return response;
};

const handleCompleteAutoRequest = async ({ _id, data }: any) => {
  const uri = `v1/autorequests/${_id}/complete`;
  const response = patchData({ data, uri });
  return response;
};

const handleUpdateAutoBusinessUnit = async ({ _id, data }: any) => {
  const uri = `v1/autorequests/${_id}/business-unit`;
  const response = patchData({ data, uri });
  return response;
};

const handleDeleteAutoRequest = async ({ _id, data }: any) => {
  const uri = `v1/autorequests/${_id}`;
  const response = deleteData({ data, uri });
  return response;
};

const handleApproveAutoRequest = async ({ _id, data }: any) => {
  const uri = `v1/autorequests/${_id}/approve`;
  const response = patchData({ data, uri });
  return response;
};

const handleFetchMonthlyRequests = async ({ startDate, endDate }: any) => {
  const uri = `v1/autorequests/stats/monthly?startDate=${startDate}&endDate=${endDate}`;
  const response = fetchData({ uri });
  return response;
};

const handleFetchRequestsByUnit = async ({ startDate, endDate }: any) => {
  const uri = `v1/autorequests/stats/unit?startDate=${startDate}&endDate=${endDate}`;
  const response = fetchData({ uri });
  return response;
};

const handleFetchRequestsByRole = async ({ startDate, endDate }: any) => {
  const uri = `v1/autorequests/stats/role?startDate=${startDate}&endDate=${endDate}`;
  const response = fetchData({ uri });
  return response;
};

export {
  handleFetchAutoRequests,
  handleFetchAutoRequest,
  handleAcceptAutoRequest,
  handleRejectAutoRequest,
  handleExportAutoRequests,
  handleCreateAutoRequest,
  handleUpdateAutoRequest,
  handleDeleteAutoRequest,
  handleUpdateAutoRequester,
  handleUpdateRequestedFor,
  handleUpdateRequestedDate,
  handleUpdateDateApproved,
  handleUpdateDateExecuted,
  handleCompleteAutoRequest,
  handleUpdateAutoExecutor,
  handleMoveToAutoExecutor,
  handleUpdateAutoApprover,
  handleFetchAutoRequestsCount,
  handleFetchMonthlyRequests,
  handleFetchRequestsByUnit,
  handleFetchRequestsByRole,
  handleUpdateAutoBusinessUnit,
  handleApproveAutoRequest,
};
